const REDIRECT_BASE_URL = 'https://app.local';

/**
 * Turns an auth redirect query parameter into an in-app path.
 *
 * Both `arkusze` and `/arkusze` are accepted. Absolute and protocol-relative
 * URLs are rejected so auth links cannot be used as open redirects.
 */
export const getSafeAuthRedirectPath = (redirectTo: string | null): string | null => {
  if (!redirectTo) {
    return null;
  }

  try {
    const url = new URL(redirectTo, `${REDIRECT_BASE_URL}/`);

    if (url.origin !== REDIRECT_BASE_URL) {
      return null;
    }

    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_error) {
    return null;
  }
};

